import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import styles from "./AccountHealth.module.css";

export default function AccountHealth() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get("/ai/account-health")
      .then((res) => setData(res.data))
      .catch(() => setError("Erro ao carregar health score."))
      .finally(() => setLoading(false));
  }, []);

  const getScoreColor = (score) => {
    if (score >= 75) return "#22c55e";
    if (score >= 50) return "#f59e0b";
    return "#ef4444";
  };

  const BREAKDOWN_LABEL = { profile: "Perfil", activity: "Atividade", automation: "Automação" };
  const BREAKDOWN_MAX = { profile: 40, activity: 40, automation: 20 };

  const QUICK_ACTIONS = [
    { label: "Conectar WhatsApp", path: "/dashboard" },
    { label: "Cadastrar serviços", path: "/business/services" },
    { label: "Configurar IA", path: "/business/settings" },
    { label: "Ver relatórios", path: "/business/reports" },
  ];

  return (
    <div className={styles.container}>
      <h1>Saúde da Conta</h1>

      {loading && <p className={styles.loading}>Calculando...</p>}
      {error && <p className={styles.error}>{error}</p>}

      {data && (
        <>
          <div className={styles.scoreCard}>
            <div
              className={styles.gauge}
              style={{ "--score": data.score, "--color": getScoreColor(data.score) }}
            >
              <span className={styles.scoreValue} style={{ color: getScoreColor(data.score) }}>
                {data.score}
              </span>
              <span className={styles.scoreLabel}>/ 100</span>
            </div>

            <div className={styles.breakdown}>
              {Object.entries(data.breakdown ?? {}).map(([key, value]) => (
                <div key={key} className={styles.breakdownItem}>
                  <div className={styles.breakdownLabel}>
                    <span>{BREAKDOWN_LABEL[key] ?? key}</span>
                    <span>{value}/{BREAKDOWN_MAX[key] ?? 100}</span>
                  </div>
                  <div className={styles.progressBar}>
                    <div
                      className={styles.progress}
                      style={{
                        width: `${(value / (BREAKDOWN_MAX[key] ?? 100)) * 100}%`,
                        background: getScoreColor((value / (BREAKDOWN_MAX[key] ?? 100)) * 100),
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.section}>
            <h2>Insights</h2>
            <ul className={styles.insights}>
              {(data.insights ?? []).map((insight, i) => (
                <li key={i} className={styles.insight}>
                  <span className={styles.insightIcon}>💡</span>
                  {insight}
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.section}>
            <h2>Ações rápidas</h2>
            <div className={styles.actions}>
              {QUICK_ACTIONS.map((a) => (
                <button key={a.label} className={styles.actionBtn} onClick={() => navigate(a.path)}>
                  {a.label}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
